import http from './http'
/**公共post ghj*/
export function sysPost(that,args, callback, errorCallback) {
	that.$root.spinShow=true;
	http.httpRequest(args.url, 'post', args.data).then(res => {
		that.$root.spinShow=false;
		if (res.Code == 0) {
			if(callback) callback(res.Data);
		} else {
			if(res.Code==401) that.$Message.info(res.Msg);
			else{
				if(errorCallback) return errorCallback(res);
				else  that.$Message.info(res.Msg);
			}
		}
	})
}

export function sysPostWx(that,args, callback, errorCallback) {
	that.$root.spinShow=true;
	http.wxHttpRequest(args.url, 'post', args.data).then(res => {
		that.$root.spinShow=false;
		if (res.Code == 0) {
			if(callback) callback(res.Data);
		} else {
			if(res.Code==401) that.$Message.info(res.Msg);
			else{
				if(errorCallback) return errorCallback(res);
				else  that.$Message.info(res.Msg);
			}
		}
	})
}